// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout principal */
.tabela-container {
    display: flex;
    justify-content: space-between;
    margin: 20px;
    gap: 20px;
    padding-top: 100px;
}

/* Container de cada tabela */
.tabela-dados-container {
    flex: 1 1;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-family: 'Arial', sans-serif;
    overflow-x: auto;
}

/* Título das tabelas */
.tabela-dados-container h2 {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    text-align: center;
    margin-bottom: 15px;
}

/* Estilos para a tabela */
.tabela-reforma {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.tabela-reforma th,
.tabela-reforma td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
}

.tabela-reforma th {
    background-color: #f4f4f4;
    font-weight: bold;
    text-align: center;
}

/* Estilos para a paginação */
.paginacao {
    display: flex;
    justify-content: center;
    gap: 5px;
    margin-top: 10px;
}

.paginacao button {
    padding: 5px 10px;
    border: 1px solid #ddd;
    background-color: #f4f4f4;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.paginacao button.active {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
}

.paginacao button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.paginacao button:hover:not(:disabled) {
    background-color: #007bff;
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/conhecimento/styles.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,SAAS;IACT,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,SAAO;IACP,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":["/* Layout principal */\n.tabela-container {\n    display: flex;\n    justify-content: space-between;\n    margin: 20px;\n    gap: 20px;\n    padding-top: 100px;\n}\n\n/* Container de cada tabela */\n.tabela-dados-container {\n    flex: 1;\n    background-color: #f9f9f9;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-family: 'Arial', sans-serif;\n    overflow-x: auto;\n}\n\n/* Título das tabelas */\n.tabela-dados-container h2 {\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    text-align: center;\n    margin-bottom: 15px;\n}\n\n/* Estilos para a tabela */\n.tabela-reforma {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n}\n\n.tabela-reforma th,\n.tabela-reforma td {\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: left;\n}\n\n.tabela-reforma th {\n    background-color: #f4f4f4;\n    font-weight: bold;\n    text-align: center;\n}\n\n/* Estilos para a paginação */\n.paginacao {\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n    margin-top: 10px;\n}\n\n.paginacao button {\n    padding: 5px 10px;\n    border: 1px solid #ddd;\n    background-color: #f4f4f4;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.paginacao button.active {\n    background-color: #007bff;\n    color: white;\n    border-color: #007bff;\n}\n\n.paginacao button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.paginacao button:hover:not(:disabled) {\n    background-color: #007bff;\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
